import React, { useState, Fragment } from "react";
import { Helmet } from "react-helmet";
import { NEW_PATIENT } from "../../queries/patient.query";
import { Mutation } from "react-apollo";
import LoadingSpin from "../../partials/loading";

import FileUpload from "../../util/FileUpload";
import { toast } from "react-toastify";
import { CleanMessage, AppName } from "../../util/app";
import DatePicker from "react-datepicker";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

function CreatePatient(props) {
    const [name, setName] = useState("");
    const [hcn, setHcn] = useState("");
    const [dob, setDob] = useState(new Date());
    const [gender, setGender] = useState("");
    const [occupation, setOccupation] = useState("");
    const [tel_number, setMobile] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [postCode, setPostCode] = useState(null);
    const [image, setImage] = useState(null);
    const [gp, setGp] = useState({});

    const newObject = {
        name,
        hcn,
        dob,
        gender,
        occupation,
        tel_number,
        email,
        address,
        image,
        postalCode: postCode,
        gp,
    };

    const title = "Create Patient";

    const onCancel = () => {
        props.history.goBack();
    };

    return (
        <Mutation
            mutation={NEW_PATIENT}
            onCompleted={(data) => {
                toast.success(data.NewPatient.message);
                sendNotification(data.NewPatient.doc, ACTION_TYPE.CREATE, EVENT_TARGET.PATIENT);
                props.history.push("/home/clinical-note/ward-summary");
            }}
            onError={(e) => toast.error(CleanMessage(e.message))}
        >
            {(postPatient, { loading }) => {
                return (
                    <Fragment>
                        <Helmet>
                            <title>
                                {title} | {AppName}
                            </title>
                            <link href="../../main/formlayout.css" rel="stylesheet" type="text/css" />
                        </Helmet>

                        <div className="card">
                            <div className="card-body">
                                <form
                                    onSubmit={async (e) => {
                                        e.preventDefault();

                                        await postPatient({
                                            variables: {
                                                model: newObject,
                                            },
                                        });
                                    }}
                                    encType={"multipart/form-data"}
                                >
                                    <div className="form-body">
                                        <div className="row">
                                            <div className="col-3 bg-primary text-center">
                                                <h5>Basic Information</h5>
                                            </div>

                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Name
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    name="name"
                                                                    required
                                                                    placeholder="enter full name"
                                                                    className="form-control input-height"
                                                                    onChange={(e) => setName(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                NHS
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    name="hcn"
                                                                    required
                                                                    placeholder="enter NHS number"
                                                                    className="form-control input-height"
                                                                    onChange={(e) => setHcn(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Date Of Birth
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <DatePicker onChange={(date) => setDob(date)} dateFormat="MMMM dd, yyyy" className="form-control input-height w-100" selected={dob} />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Gender
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <select className="form-control input-height" name="gender" onChange={(e) => setGender(e.target.value)} required>
                                                                    <option value="">-- Please Select --</option>
                                                                    <option value="Male">Male</option>
                                                                    <option value="Female">Female</option>
                                                                    <option value="Others">Others</option>
                                                                </select>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Occupation
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    name="occupation"
                                                                    required
                                                                    placeholder="enter occupation"
                                                                    className="form-control input-height"
                                                                    onChange={(e) => setOccupation(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Mobile No.
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    name="phone_number"
                                                                    type="tel"
                                                                    required
                                                                    placeholder="mobile number"
                                                                    className="form-control input-height"
                                                                    onChange={(e) => setMobile(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Email
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control input-height"
                                                                    name="email"
                                                                    required
                                                                    placeholder="Email Address"
                                                                    onChange={(e) => setEmail(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Post Code
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    type="text"
                                                                    className="form-control input-height"
                                                                    name="postCode"
                                                                    required
                                                                    placeholder="Enter post code"
                                                                    onChange={(e) => setPostCode(e.target.value)}
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Address
                                                                <span className="required"> * </span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <textarea
                                                                    name="home_address"
                                                                    placeholder="Home Address"
                                                                    required
                                                                    className="form-control form-control-textarea"
                                                                    rows="3"
                                                                    onChange={(e) => setAddress(e.target.value)}
                                                                ></textarea>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row">
                                            <div className="col-3 bg-primary text-center">
                                                <h5>Patient GP Information</h5>
                                            </div>

                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Name
                                                                <span className="required"> *</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    name="gp_name"
                                                                    type="text"
                                                                    required
                                                                    placeholder="enter name"
                                                                    className="form-control input-height"
                                                                    onChange={(e) =>
                                                                        setGp({
                                                                            ...gp,
                                                                            name: e.target.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Email Address
                                                                <span className="required"> *</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    name="gp_email"
                                                                    type="email"
                                                                    required
                                                                    placeholder="enter email"
                                                                    className="form-control input-height"
                                                                    onChange={({ currentTarget }) =>
                                                                        setGp({
                                                                            ...gp,
                                                                            email: currentTarget.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Phone Number
                                                                <span className="required"> *</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    name="gp_mobile"
                                                                    type="text"
                                                                    required
                                                                    placeholder="enter mobile"
                                                                    className="form-control input-height"
                                                                    onChange={({ currentTarget }) =>
                                                                        setGp({
                                                                            ...gp,
                                                                            mobile: currentTarget.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Contact Address
                                                                <span className="required"> *</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <textarea
                                                                    name="gp_address"
                                                                    placeholder="Home Address"
                                                                    required
                                                                    className="form-control form-control-textarea"
                                                                    rows="3"
                                                                    onChange={(e) =>
                                                                        setGp({
                                                                            ...gp,
                                                                            address: e.target.value,
                                                                        })
                                                                    }
                                                                ></textarea>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>
                                                                Post Code
                                                                <span className="required"> *</span>
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <div className="col-8">
                                                                <input
                                                                    name="gp_code"
                                                                    type="text"
                                                                    required
                                                                    placeholder="enter post code"
                                                                    className="form-control input-height"
                                                                    onChange={({ currentTarget }) =>
                                                                        setGp({
                                                                            ...gp,
                                                                            postCode: currentTarget.value,
                                                                        })
                                                                    }
                                                                />
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div className="row">
                                            <div className="col-3 bg-primary text-center">
                                                <h5>Patient Profile Picture</h5>
                                            </div>

                                            <table className="table table-bordered">
                                                <tbody>
                                                    <tr>
                                                        <td style={{ backgroundColor: "aliceblue", width: "30%" }}>
                                                            <strong>Patient Profile Picture *</strong>
                                                        </td>
                                                        <td>
                                                            <FileUpload title="" onData={(item) => setImage(item.path)} />
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="form-group">
                                            <LoadingSpin loading={loading} />
                                        </div>

                                        <div className="text-center" style={{ marginTop: "4em" }}>
                                            <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 margin-right-10 btn-circle">
                                                <i className="material-icons text-danger">cancel</i>
                                                Cancel
                                            </button>
                                            &nbsp;&nbsp;
                                            <button type="submit" disabled={loading} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-b-10 btn-circle btn-success">
                                                Submit Form
                                                <i className="material-icons">arrow_right_alt</i>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Fragment>
                );
            }}
        </Mutation>
    );
}

export default CreatePatient;
